import { render, staticRenderFns } from "./Apportionment.vue?vue&type=template&id=5b142852&"
import script from "./Apportionment.vue?vue&type=script&lang=js&"
export * from "./Apportionment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports